import classNames from "classnames";
import type React from "react";
import type { Message } from "../../common/types/Message";
import type { MessageSenderRole } from "../../common/types/Roles";
import { formatChatMessageDate } from "../../utils/time.util";
import InlineTextDelimiter from "../Common/InlineTextDelimiter";
import "./ChatMessageAuthorRow.css";

type Props = {
    messageBase: Message;
    sender: MessageSenderRole;
    onRequestLinkClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    className?: string;
};

function ChatMessageAuthorRow(props: Props) {
    const { className, messageBase, sender, onRequestLinkClick } = props;
    const {
        sentAt,
        senderName,
        editedAt,
        editorName,
        requestTitle,
        additionalNotificationAttempts,
    } = messageBase;

    return (
        <div
            className={classNames(
                "chat-message__author-row",
                `chat-message__author-row--${sender}`,
                className,
            )}
        >
            <span className="chat-message__author-row__time">
                {formatChatMessageDate(sentAt)}
            </span>
            {sender === "agent" && senderName && (
                <>
                    <InlineTextDelimiter />
                    <span className="chat-message__author-row__sender">
                        {senderName}
                    </span>
                </>
            )}
            {requestTitle && (
                <>
                    <InlineTextDelimiter />
                    <button
                        className={classNames(
                            "chat-message__author-row__request-link",
                            {
                                "chat-message__author-row__request-link--has-action":
                                    !!onRequestLinkClick,
                            },
                        )}
                        type="button"
                        onClick={onRequestLinkClick}
                    >
                        {requestTitle}
                    </button>
                </>
            )}

            {editedAt && (
                <>
                    <InlineTextDelimiter />
                    <span
                        className="chat-message__author-row__edited web-lib__tooltip web-lib__tooltip--top"
                        data-tooltip={`Edited ${formatChatMessageDate(
                            editedAt,
                        )} by ${editorName}`}
                    >
                        Edited
                    </span>
                </>
            )}

            {additionalNotificationAttempts && (
                <>
                    <InlineTextDelimiter />
                    <span
                        className="chat-message__author-row__edited web-lib__tooltip web-lib__tooltip--top"
                        data-tooltip={
                            additionalNotificationAttempts.length === 1
                                ? `Member has been renotified ${additionalNotificationAttempts.length} time`
                                : `Member has been renotified ${additionalNotificationAttempts.length} times`
                        }
                    >
                        Renotified
                    </span>
                </>
            )}
        </div>
    );
}

export default ChatMessageAuthorRow;
